import { useMutation } from '@tanstack/react-query';

import { professionalParams } from '@/hooks/use-public-schedule';
import api from '@/services/api';
import { CreateRecurrenceDto, RecurrencePlan } from '@/types/recurrence';

/**
 * Recorrência do convidado pelo perfil público (modo AUTO): mesmo builder do
 * cliente logado, mas os endpoints não exigem JWT — são escopados pelo slug e a
 * identidade vem por nome + telefone (com OTP quando ativo).
 */

export interface CreateGuestRecurrenceInput extends CreateRecurrenceDto {
  guest: { name: string; phone: string };
  otpToken?: string;
}

export interface GuestRecurrenceResult {
  enrollmentId: string;
  status: string;
  plan: RecurrencePlan;
  /** false quando o telefone já pertence a uma conta completa (aí é login). */
  accountClaimable: boolean;
}

/** Pré-visualiza a agenda montada pelo convidado (não persiste). */
export function usePreviewPublicRecurrence(
  slug: string | undefined,
  professionalId?: string | null,
) {
  return useMutation({
    mutationFn: async (dto: CreateRecurrenceDto) => {
      const res = await api.post<RecurrencePlan>(
        `/public/schedule/${slug}/recurrences/preview`,
        dto,
        { params: professionalParams(professionalId) },
      );
      return res.data;
    },
  });
}

/** Cria a recorrência do convidado como contrato PENDING_APPROVAL. */
export function useCreatePublicRecurrence(
  slug: string | undefined,
  professionalId?: string | null,
) {
  return useMutation({
    mutationFn: async (input: CreateGuestRecurrenceInput) => {
      const res = await api.post<GuestRecurrenceResult>(
        `/public/schedule/${slug}/recurrences`,
        input,
        { params: professionalParams(professionalId) },
      );
      return res.data;
    },
  });
}
